<template>
  <div
    v-bind:class="{
      'bubble white mb-2': !highlight,
      'bubble white mb-2 selected': highlight,
      'bubble white mb-2 opacity-50 disabled' : disabled
    }"
    tabindex="-1"
    aria-disabled="true"
    id="selectItem"
    @click="$emit('select')"
  >
    <div class="inner">
      <div class="image">
        <icon :type="this.type" />
      </div>
      <div class="description">
        <h2 class="m-0">{{ this.text }}</h2>
        <p class="m-0" :class="{'select-item-description' : this.value }">
          <a class="me-2 cursor-pointer" v-if="showDeleteIconOnDescription" @click="onClickDeleteIconOnDescription"><i class="icon-cross-sm fs-14 cursor-pointer" style="color: #DF5A3E;"></i></a>
          {{ this.description }}
        </p>
      </div>
      <div class="icon" v-if="this.canSelect">
        <i class="icon-check"></i>
      </div>
      <div class="" v-if="!this.canSelect && !this.hideIcon">
        <icon :value="this.value" />
      </div>
    </div>
  </div>
</template>

<script>
import icon from "../components/Icon.vue";

export default {
  name: "select-item",
  components: {
    icon
  },
  props: {
    text: String,
    description: String,
    type: String,
    canSelect: Boolean,
    value: String,
    highlightSelect: Boolean,
    hideIcon: Boolean,
    disabled: Boolean,
    showDeleteIconOnDescription: Boolean
  },
  computed: {
    highlight() {
      if (this.canSelect) {
        return this.highlightSelect;
      }
      else {
        return this.canSelect;
      }
    }
  },
  methods: {
    onClickDeleteIconOnDescription() {
      this.$emit("onClickDeleteIconOnDescription");
    }
  }
}
</script>

<style lang="scss" restr>
  .select-item-description {
    white-space: nowrap;
    overflow: hidden;
  }

  .description {
    text-align: left;
  }
</style>
